import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from "react";
import { faCopy, faCheck } from '@fortawesome/free-solid-svg-icons'

import useDictionary from '../hooks/useDictionary';

export default function CopyButton ({ tekst }) {

  const [skopiowano, setSkopiowano] = useState(false);

  const dictionary = useDictionary();

  const kopiuj = () => {
    const el = document.createElement("textarea");
    el.value = tekst;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setSkopiowano(true);
    setTimeout(() => setSkopiowano(false), 3000);
  };

  return (
    <span className="copy-button" onClick={kopiuj}>
      {skopiowano ? <span className="copied-state"><FontAwesomeIcon icon={faCheck} /> {dictionary.COPIED}!</span> : <><FontAwesomeIcon icon={faCopy} /> {tekst}</> }
    </span>
  );

};